<div class="poster-image-wrapper position-relative">
    <app-sensitive-content-container
        *ngIf="isCautionFlagContainerDisplayed"
        [actionButtonName]="cautionFlagButtonName"
        class="content-flags-overlay"
    >
    </app-sensitive-content-container>
    <div
        class="image-container"
        [ngStyle]="{ 'background-image': 'url(\'' + imageMedia.posterImage.itsURL + '\')' }"
        [title]="imageMedia.posterImage.getAltText()"
    >
        <a
            href="#"
            (click)="expand($event)"
            [attr.aria-describedby]="imageMedia.ARIADescription ? 'image-long-description' : null"
        >
            <span class="expand"> <app-icon type="Expand"></app-icon> Expand </span>
        </a>
        <p id="image-long-description" *ngIf="imageMedia.ARIADescription">
            {{ imageMedia.ARIADescription }}
        </p>
    </div>
</div>
